import { render, staticRenderFns } from "./AssetItem.vue?vue&type=template&id=85a72fd2"
import script from "./AssetItem.vue?vue&type=script&lang=js"
export * from "./AssetItem.vue?vue&type=script&lang=js"
import style0 from "./AssetItem.vue?vue&type=style&index=0&id=85a72fd2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports